// BARCINO - Page Panier (funnel)
// Hors Barba - initialise sur DOMContentLoaded si .bc-panier est present.

const barcinoPanier = {

    _el: null,
    _lang: 'fr',
    _urlModifier: '',
    _urlSupprimer: '',
    _urlCoupon: '',
    _urlCouponSupprimer: '',
    _i18nShippingFree: '',
    _i18nShippingPending: '',
    _i18nCurrency: '',
    _i18nCouponApplied: '',
    _i18nCouponError: '',
    _csrfName: '',
    _csrfCookie: '',
    _csrfHash: '',
    _bound: false,

    init() {
        this._el = document.querySelector('.bc-panier');
        if (!this._el) return;

        this._lang = this._el.dataset.lang || 'fr';
        this._urlModifier = this._el.dataset.urlModifier || `/${this._lang}/panier/modifier`;
        this._urlSupprimer = this._el.dataset.urlSupprimer || `/${this._lang}/panier/supprimer`;
        this._urlCoupon = this._el.dataset.urlCoupon || `/${this._lang}/panier/coupon`;
        this._urlCouponSupprimer = this._el.dataset.urlCouponSupprimer || `/${this._lang}/panier/coupon/supprimer`;
        this._i18nShippingFree = this._el.dataset.i18nShippingFree || '';
        this._i18nShippingPending = this._el.dataset.i18nShippingPending || '';
        this._i18nCurrency = this._el.dataset.i18nCurrency || '';
        this._i18nCouponApplied = this._el.dataset.i18nCouponApplied || '';
        this._i18nCouponError = this._el.dataset.i18nCouponError || '';
        this._csrfName = this._el.dataset.csrfName || '';
        this._csrfCookie = this._el.dataset.csrfCookie || '';
        this._csrfHash = this._el.dataset.csrfHash || '';

        this._bindEvents();
        this._bindCoupon();
    },

    _bindEvents() {
        const list = document.getElementById('bc-panier-list');
        if (!list) return;
        if (this._bound) return;
        this._bound = true;

        list.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-qty-action]');
            if (!btn) return;

            const item = btn.closest('.bc-panier__item');
            if (!item) return;

            const itemId = item.dataset.itemId;
            const qtyEl = item.querySelector('[data-qty]');
            const action = btn.dataset.qtyAction;
            const qty = parseInt(qtyEl?.textContent || '1', 10);

            if (action === 'plus') {
                this._updateQuantity(item, itemId, qty + 1);
                return;
            }

            if (action === 'minus' && qty <= 1) {
                this._removeItem(item, itemId);
                return;
            }

            if (action === 'minus') {
                this._updateQuantity(item, itemId, qty - 1);
            }
        });
    },

    _bindCoupon() {
        const form = document.getElementById('bc-coupon-form');
        const removeBtn = document.getElementById('bc-coupon-remove');
        const suggestions = document.getElementById('bc-coupon-suggestions');

        form?.addEventListener('submit', (e) => {
            e.preventDefault();
            this._applyCoupon(form);
        });

        removeBtn?.addEventListener('click', () => {
            this._removeCoupon();
        });

        suggestions?.addEventListener('click', (e) => {
            const btn = e.target.closest('[data-coupon-suggestion]');
            if (!btn || !form) return;
            const input = form.querySelector('input[name="coupon"]');
            if (input) input.value = btn.dataset.couponSuggestion;
            this._applyCoupon(form);
        });
    },

    async _applyCoupon(form) {
        const input = form.querySelector('input[name="coupon"]');
        const button = form.querySelector('button[type="submit"]');
        const feedback = document.getElementById('bc-coupon-feedback');
        const code = input?.value.trim() || '';

        if (feedback) feedback.textContent = '';
        if (!code) {
            if (feedback) feedback.textContent = this._i18nCouponError;
            return;
        }

        button?.setAttribute('disabled', 'true');

        try {
            const res = await fetch(this._urlCoupon, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: this._buildBody({ coupon: code }),
            });

            const data = await res.json();
            if (!res.ok || !data.success) {
                if (feedback) feedback.textContent = data.error || this._i18nCouponError;
                return;
            }

            this._showCouponApplied(code);
            this._updateTotals(data.totals);
        } catch (err) {
            console.error('[barcinoPanier] apply coupon', err);
            if (feedback) feedback.textContent = this._i18nCouponError;
        } finally {
            button?.removeAttribute('disabled');
        }
    },

    async _removeCoupon() {
        try {
            const res = await fetch(this._urlCouponSupprimer, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: this._buildBody({}),
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();

            this._showCouponForm();
            this._updateTotals(data.totals);
        } catch (err) {
            console.error('[barcinoPanier] remove coupon', err);
        }
    },

    _showCouponApplied(code) {
        const form = document.getElementById('bc-coupon-form');
        const applied = document.getElementById('bc-coupon-applied');
        const label = applied?.querySelector('[data-coupon-applied-label]');
        const feedback = document.getElementById('bc-coupon-feedback');
        const suggestions = document.getElementById('bc-coupon-suggestions');

        if (form) form.hidden = true;
        if (applied) applied.hidden = false;
        if (label) label.textContent = this._i18nCouponApplied.replace('%s', code);
        if (feedback) feedback.textContent = '';

        suggestions?.querySelectorAll('[data-coupon-suggestion]').forEach((btn) => {
            const isApplied = btn.dataset.couponSuggestion === code;
            btn.classList.toggle('is-applied', isApplied);
            btn.disabled = isApplied;
        });
    },

    _showCouponForm() {
        const form = document.getElementById('bc-coupon-form');
        const applied = document.getElementById('bc-coupon-applied');
        const input = form?.querySelector('input[name="coupon"]');
        const suggestions = document.getElementById('bc-coupon-suggestions');

        if (form) form.hidden = false;
        if (applied) applied.hidden = true;
        if (input) input.value = '';

        suggestions?.querySelectorAll('[data-coupon-suggestion]').forEach((btn) => {
            btn.classList.remove('is-applied');
            btn.disabled = false;
        });
    },

    async _updateQuantity(itemEl, itemId, newQty) {
        this._setLoading(itemEl, true);

        try {
            const res = await fetch(this._urlModifier, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: this._buildBody({ item_id: itemId, quantity: newQty }),
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            if (!data.success) throw new Error('cart_update_failed');

            const qtyEl = itemEl.querySelector('[data-qty]');
            if (qtyEl) qtyEl.textContent = newQty;

            itemEl.dataset.qtySingle = newQty <= 1 ? '1' : '0';
            this._updateLinePrice(itemEl, newQty);
            this._updateTotals(data.totals);
            this._updateCartCount(data.cart_count);
        } catch (err) {
            console.error('[barcinoPanier] update quantity', err);
        } finally {
            this._setLoading(itemEl, false);
        }
    },

    async _removeItem(itemEl, itemId) {
        this._setLoading(itemEl, true);

        try {
            const res = await fetch(this._urlSupprimer, {
                method: 'POST',
                headers: {
                    'Content-Type': 'application/x-www-form-urlencoded; charset=UTF-8',
                    'X-Requested-With': 'XMLHttpRequest',
                },
                body: this._buildBody({ item_id: itemId }),
            });

            if (!res.ok) throw new Error(`HTTP ${res.status}`);
            const data = await res.json();
            if (!data.success) throw new Error('cart_remove_failed');

            itemEl.classList.add('is-removing');

            window.setTimeout(() => {
                itemEl.remove();
                this._updateTotals(data.totals);
                this._updateCartCount(data.cart_count);
                this._checkEmpty();
            }, 220);
        } catch (err) {
            console.error('[barcinoPanier] remove item', err);
            this._setLoading(itemEl, false);
        }
    },

    _updateLinePrice(itemEl, qty) {
        const priceEl = itemEl.querySelector('[data-line-price]');
        const unitPrice = Number.parseFloat(itemEl.dataset.unitPrice || '0');
        if (!priceEl || Number.isNaN(unitPrice)) return;

        priceEl.textContent = this._formatPrice(unitPrice * qty);
    },

    _updateTotals(totals) {
        if (!totals) return;

        const set = (sel, val) => {
            const el = document.querySelector(sel);
            if (el) el.textContent = val;
        };

        set('[data-total-subtotal]', this._formatPrice(totals.subtotal || 0));
        set('[data-total-final]', this._formatPrice(totals.total || 0));
        set(
            '[data-total-shipping]',
            totals.shipping_pending
                ? this._i18nShippingPending
                : (totals.shipping === 0 ? this._i18nShippingFree : this._formatPrice(totals.shipping || 0))
        );

        const discountLine = document.getElementById('bc-panier-discount');
        if (discountLine) {
            const hasDiscount = (totals.discount || 0) > 0;
            discountLine.hidden = !hasDiscount;
            if (hasDiscount) set('[data-total-discount]', `- ${this._formatPrice(totals.discount)}`);
        }

        const giftLine = document.getElementById('bc-panier-gift');
        if (giftLine) {
            const hasGift = !!(totals.gift && totals.gift.description);
            giftLine.hidden = !hasGift;
            if (hasGift) set('[data-total-gift]', totals.gift.description);
        }

    },

    _setProgress(fill, pct) {
        Array.from(fill.classList).forEach((className) => {
            if (className.indexOf('_p-') === 0) {
                fill.classList.remove(className);
            }
        });
        fill.classList.add(`_p-${pct}`);
    },

    _updateCartCount(count) {
        document.querySelectorAll('[data-cart-count]').forEach((badge) => {
            badge.textContent = count > 0 ? count : '';
        });
    },

    _checkEmpty() {
        const list = document.getElementById('bc-panier-list');
        if (!list || list.children.length > 0) return;
        window.location.reload();
    },

    _setLoading(itemEl, loading) {
        itemEl.classList.toggle('is-loading', loading);
    },

    _formatNumber(value) {
        return new Intl.NumberFormat(this._lang === 'en' ? 'en-GB' : 'fr-FR', {
            minimumFractionDigits: 2,
            maximumFractionDigits: 2,
        }).format(value);
    },

    _formatPrice(value) {
        return `${this._formatNumber(value)} ${this._i18nCurrency}`;
    },

    _buildBody(payload) {
        const body = new URLSearchParams();
        Object.entries(payload).forEach(([key, value]) => {
            body.set(key, value);
        });

        if (this._csrfName) {
            body.set(this._csrfName, this._getCsrfHash());
        }

        return body.toString();
    },

    _getCsrfHash() {
        if (this._csrfCookie) {
            const match = document.cookie.match(new RegExp(`${this._csrfCookie}=([^;]+)`));
            if (match) return decodeURIComponent(match[1]);
        }

        return this._csrfHash;
    },
};

if (typeof document !== 'undefined') {
    document.addEventListener('DOMContentLoaded', () => {
        if (document.querySelector('.bc-panier')) {
            barcinoPanier.init();
        }
    });
}

export default barcinoPanier;
